import react from 'react';

const Svg = react.forwardRef(function Svg(props, ref) {
    return react.createElement('svg', { ...props, ref }, props.children);
});

export default Svg;
